export default __webpack_public_path__ + "static/media/profile-photo.7ac8c193.jpg";